"use client"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

interface DeleteAccountDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  accountName?: string
  isDeleting?: boolean
}

export function DeleteAccountDialog({
  open,
  onOpenChange,
  onConfirm,
  accountName,
  isDeleting = false,
}: DeleteAccountDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent style={{ backgroundColor: '#ffffff' }}>
        <AlertDialogHeader>
          <AlertDialogTitle>ยืนยันการลบบัญชี</AlertDialogTitle>
          <AlertDialogDescription>
            คุณต้องการลบบัญชี{accountName ? ` "${accountName}"` : 'นี้'} ใช่หรือไม่?
            <br />
            <span className="text-red-500 font-medium">
              การลบจะไม่สามารถกู้คืนได้
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>
            ยกเลิก
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault()
              onConfirm()
            }}
            disabled={isDeleting}
            className="bg-red-500 hover:bg-red-600"
          >
            {isDeleting ? 'กำลังลบ...' : 'ลบบัญชี'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
